import { Inject, Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ReuseTabService } from '@delon/abc';
import { OrgChooseService } from '../services/orgchoose.service';
import { _HttpClient } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd';
import { YhFlowService } from './yhFlow.service';

declare var CryptoJS: any;
declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  // 敏感词库字段
  private sensitiveWords = 'AV|hz|sm|PK|PX|C4|usk|flg|GCD|gcd|GHB|rfa|sex|TND|voa|.ru|.cc|SQ|tmd|nnd|89-|cnd|dpp|TMD|xxx|t56|LSD|qy6|TEL|18dy|pn95|3退|A级|A片|fuck|J巴|lama|nacb|nmis|porn|shit|suck|svdc|taip|TNND|wo98|操B|插B|大b|二B|狗b|傻B|傻X|F·B|T·W|Z·W|Y·D|S·F|a片|2奶|k粉|cdjp|dafa|dfdz|falu|>jnv|9评|G点|MDMA|SARS|红K|.exe|6合|c-sz|hqzg|it01|wj2y|FUCK|反G|六4|法L|9坪|h漫|h图|99dv|嫩b|RX65|T牌|qvod|3箭|654K|55MM|AK47|ATOM|b毛|3健|3棱|CP99|G水|lqb78|zsgnw|lqb18|cxmyw|dk555|laohj|we399|h59me|boxun|17大|18禁|3d肉|Kx粉|naive|paper|黄JU|FALun|yinh|anime|bitch|Bjork|bjork|Party|fldfh|598gj|ab003|baiok|buslz|djkdh|haosf|hy898|jsxys|ka888|ka999|kaobi|meiti|qqywf|s3186|typou|weizi|wt800|xgzrc|xj818|zdbmm|zs007|zt286|bb弹|fa轮|看jj|daai8|zqfpw|台du|89之|tusha|FL功|自fe|9ping|zifen|XX功|看JJ|S2940|HCCH2|630XP|54手|92手|63式|77手|38式|TV棒|64手|42酮|TVUSB|DM528|762mm|qiang|ADBOX|80色|qi狗|GLOCK|M1911|假BI|54狗|64狗|色BB|92式|64式|54式|77式|BB弹|槍qq腐败|贪污|gcd|共贪党|gongchandang|阿共|共一产一党|产党共|公产党|工产党|共c党|共x党|共铲|供产|共惨|供铲党|供铲谠|供铲裆|共残党|共残主义|共产主义的幽灵|拱铲|老共|中珙|中gong|gc党|贡挡|gong党|g产|狗产蛋|共残裆|恶党|邪党|共产专制|共产王朝|裆中央|土共|土g|共狗|g匪|共匪|仇共|共产党腐败|共产党专制|共产党的报应|共产党的末日|communistparty|症腐|政腐|政付|正府|政俯|政f|zhengfu|政zhi|挡中央|档中央|爱女人|爱液|按摩棒|拔出来|爆草|包二奶|暴干|暴奸|暴乳|爆乳|暴淫|屄|被操|被插|被干|逼奸|仓井空|插暴|操逼|操黑|操烂|肏你|肏死|操死|操我|厕奴|插比|插b|插逼|插进|插你|插我|插阴|潮吹|潮喷|成人dv|成人电影|成人论坛|成人小说|成人电|成人电影|成人卡通|成人聊|成人片|成人视|成人图|成人文|成人小|成人电影|成人论坛|成人色情|成人网站|成人文学|成人小说|艳情小说|成人游戏|吃精|赤裸|抽插|扌由插|抽一插|春药|大波|大力抽送|大乳|荡妇|荡女|盗撮|多人轮|发浪|放尿|肥逼|粉穴|封面女郎|风月大陆|干死你|干穴|肛交|肛门|龟头|裹本|国产av|好嫩|豪乳|黑逼|后庭|后穴|虎骑|花花公子|换妻俱乐部|黄片|几吧|鸡吧|鸡巴|鸡奸|寂寞男|寂寞女|妓女|激情|集体淫|奸情|叫床|脚交|金鳞岂是池中物|金麟岂是池中物|精液|就去日|巨屌|菊花洞|菊门|巨奶|巨乳|菊穴|开苞|口爆|口活|口交|口射|口淫|裤袜|狂操|狂插|浪逼|浪妇|浪叫|浪女|狼友|聊性|流淫|铃木麻|凌辱|漏乳|露b|乱交|乱伦|轮暴|轮操|轮奸|裸陪|买春|美逼|美少妇|美乳|美腿|美穴|美幼|秘唇|迷奸|密穴|蜜穴|蜜液|摸奶|摸胸|母奸|奈美|奶子|男奴|内射|嫩逼|嫩女|嫩穴|捏弄|女优|炮友|砲友|喷精|屁眼|品香堂|前凸后翘|强jian|强暴|强奸处女|情趣用品|情色|拳交|全裸|群交|惹火身材|人妻|人兽|日逼|日烂|肉棒|肉逼|肉唇|肉洞|肉缝|肉棍|肉茎|肉具|揉乳|肉穴|肉欲|乳爆|乳房|乳沟|乳交|乳头|三级片|骚逼|骚比|骚女|骚水|骚穴|色逼|色界|色猫|色盟|色情网站|色区|色色|色诱|色欲|色b|少年阿宾|少修正|射爽|射颜|食精|释欲|兽奸|兽交|手淫|兽欲|熟妇|熟母|熟女|爽片|爽死我了|双臀|死逼|丝袜|丝诱|松岛枫|酥痒|汤加丽|套弄|体奸|体位|舔脚|舔阴|调教|偷欢|偷拍|推油|脱内裤|文做|我就色|无码|舞女|无修正|吸精|夏川纯|相奸|小逼|校鸡|小穴|小xue|写真|性感妖娆|性感诱惑|性虎|性饥渴|性技巧|性交|性奴|性虐|性息|性欲|胸推|穴口|学生妹|穴图|亚情|颜射|阳具|杨思敏|要射了|夜勤病栋|一本道|一夜欢|一夜情|一ye情|阴部|淫虫|阴唇|淫荡|阴道|淫电影|阴阜|淫妇|淫河|阴核|阴户|淫贱|淫叫|淫教师|阴茎|阴精|淫浪|淫媚|淫糜|淫魔|淫母|淫女|淫虐|淫妻|淫情|淫色|淫声浪语|淫兽学园|淫书|淫术炼金士|淫水|淫娃|淫威|淫亵|淫样|淫液|淫照|阴b|应召|幼交|欲火|欲女|玉女心经|玉蒲团|玉乳|欲仙欲死|玉穴|援交|原味内衣|援助交际|张筱雨|招鸡|招妓|中年美妇|抓胸|自拍|自慰|作爱|18禁|99bb|a4u|a4y|adult|amateur|anal|a片|fuck|gay片|g点|g片|incest|porn|secom|sexinsex|sm女王|xiao77|xing伴侣|tokyohot|yin荡|贱人|装b|大sb|傻逼|傻b|煞逼|煞笔|刹笔|傻比|沙比|欠干|婊子养的|我日你|我操|我草|卧艹|卧槽|爆你菊|艹你|cao你|你他妈|真他妈|别他吗|草你吗|草你丫|操你妈|擦你妈|操你娘|操他妈|日你妈|干你妈|干你娘|娘西皮|狗操|狗草|狗杂种|狗日的|操你祖宗|操你全家|操你大爷|妈逼|你麻痹|麻痹的|妈了个逼|马勒|狗娘养|贱比|贱b|下贱|死全家|全家死光|全家不得好死|全家死绝|白痴|无耻|sb|杀b|你吗b|你妈的|婊子|贱货|人渣|混蛋|性伴侣|精子|射精|诱奸|强奸|做爱|性爱|发生关系|按摩|快感|处男|猛男|少妇|屌|屁股|下体|a片|内裤|浑圆|咪咪|发情|刺激|白嫩|粉嫩|兽性|风骚|呻吟|sm|阉割|高潮|裸露|不穿|一丝不挂|脱光|干你|干死|我干|裙中性运动|乱奸|乱伦|乱伦类|乱伦小|伦理大|伦理电影|伦理毛|伦理片|裸聊|裸聊网|裸体写真|裸舞视|裸照|美女裸体|美女写真|美女上门|美艳少妇|妹按摩|妹上门|迷幻药|迷幻藥|迷昏口|迷昏药|迷昏藥|迷魂香|迷魂药|迷魂藥|迷奸粉|迷奸药|迷情粉|迷情水|迷情药|迷药|迷藥|谜奸药|骚妇|骚货|骚浪|骚女|骚嘴|色电影|色妹妹|色情表演|色情电影|色情服务|色情图片|色情小说|色情影片|色情表演|色情电影|色情服务|色情片|色视频|色小说|性伴侣|性服务|性福情|性感少|性伙伴|性交|性交视频|性交图片|性奴|性奴集中营|性虐|阴唇|阴道|阴蒂|阴户|阴间来电|阴茎|阴茎增大|阴茎助勃|阴毛|陰唇|陰道|陰戶|淫荡|淫荡美女|淫荡视频|淫荡照片|淫乱|淫靡|淫魔|淫魔舞|淫女|淫情女|淫肉|淫騷妹|淫兽|淫兽学|淫水|淫穴|morphine|摇头丸|迷药|乖乖粉|narcotic|麻醉药|精神药品|爱女人|爱液|按摩棒|拔出来|爆草|包二奶|暴干|暴奸|暴乳|爆乳|暴淫|屄|被操|被插|被干|逼奸|仓井空|插暴|操逼|操黑|操烂|肏你|肏死|操死|操我|厕奴|插比|插b|插逼|插进|插你|插我|插阴|潮吹|潮喷|成人电影|成人论坛|成人色情|成人网站|成人文学|成人小说|艳情小说|成人游戏|吃精|赤裸|抽插|扌由插|抽一插|春药|大波|大力抽送|大乳|荡妇|荡女|盗撮|多人轮|发浪|放尿|肥逼|粉穴|封面女郎|风月大陆|干死你|干穴|肛交|肛门|龟头|裹本|国产av|好嫩|豪乳|黑逼|后庭|后穴|虎骑|花花公子|换妻俱乐部|黄片|几吧|鸡吧|鸡巴|鸡奸|寂寞男|寂寞女|妓女|激情|集体淫|奸情|叫床|脚交|金鳞岂是池中物|金麟岂是池中物|精液|就去日|巨屌|菊花洞|菊门|巨奶|巨乳|菊穴|开苞|口爆|口活|口交|口射|口淫|裤袜|狂操|狂插|浪逼|浪妇|浪叫|浪女|狼友|聊性|流淫|铃木麻|凌辱|漏乳|露b|乱交|乱伦|轮暴|轮操|轮奸|裸陪|买春|美逼|美少妇|美乳|美腿|美穴|美幼|秘唇|迷奸|密穴|蜜穴|蜜液|摸奶|摸胸|母奸|奈美|奶子|男奴|内射|嫩逼|嫩女|嫩穴|捏弄|女优|炮友|砲友|喷精|屁眼|品香堂|前凸后翘|强jian|强暴|强奸处女|情趣用品|情色|拳交|全裸|群交|惹火身材|人妻|人兽|日逼|日烂|肉棒|肉逼|肉唇|肉洞|肉缝|肉棍|肉茎|肉具|揉乳|肉穴|肉欲|乳爆|乳房|乳沟|乳交|乳头|三级片|骚逼|骚比|骚女|骚水|骚穴|色逼|色界|色猫|色盟|色情网站|色区|色色|色诱|色欲|色b|少年阿宾|少修正|射爽|射颜|食精|释欲|兽奸|兽交|手淫|兽欲|熟妇|熟母|熟女|爽片|爽死我了|双臀|死逼|丝袜|丝诱|松岛枫|酥痒|汤加丽|套弄|体奸|体位|舔脚|舔阴|调教|偷欢|偷拍|推油|脱内裤|文做|我就色|无码|舞女|无修正|吸精|夏川纯|相奸|小逼|校鸡|小穴|小xue性感妖娆|性感诱惑|性虎|性饥渴|性技巧|性交|性奴|性虐|性息|性欲|胸推|穴口|学生妹|穴图|亚情|颜射|阳具|杨思敏|要射了|夜勤病栋|一本道|一夜欢|一夜情|一ye情|阴部|淫虫|阴唇|淫荡|阴道|淫电影|阴阜|淫妇|淫河|阴核|阴户|淫贱|淫叫|淫教师|阴茎|阴精|淫浪|淫媚|淫糜|淫魔|淫母|淫女|淫虐|淫妻|淫情|淫色|淫声浪语|淫兽学园|淫书|淫术炼金士|淫水|淫娃|淫威|淫亵|淫样|淫液|淫照|阴b|应召|幼交|欲火|欲女|玉女心经|玉蒲团|玉乳|欲仙欲死|玉穴|援交|原味内衣|援助交际|招鸡|招妓|中年美妇|抓胸|自拍|自慰|作爱|18禁|99bb|a4u|a4y|adult|amateur|anal|a片|fuck|gay片|g点|g片|hardcore|h动画|h动漫|incest|porn|secom|sexinsex|sm女王|xiao77|xing伴侣|tokyohot|yin荡|反党|反共';
  // 全局loading窗体显示标识
  public isFetching = false;

  constructor(
    private router: Router,
    private orgServe: OrgChooseService,
    private modal: NzModalService,
    public http: _HttpClient,
    private message: NzMessageService,
    private yhFlowService: YhFlowService,
    @Inject(ReuseTabService) private reuseTabService: ReuseTabService,
  ) {}

  // 铭感词校验
  public checkSensitiveWord(str): boolean {
    const forbiddenArray = this.sensitiveWords.split('|');
    let re = '';
    for (let i = 0; i < forbiddenArray.length; i++) {
      if (i === forbiddenArray.length - 1) re += forbiddenArray[i];
      else re += forbiddenArray[i] + '|';
    }
    // 定义正则表示式对象
    // 利用RegExp可以动态生成正则表示式
    const pattern = new RegExp(re, 'gi');
    if (pattern.test(str)) {
      return false;
    } else {
      return true;
    }
  }

  // 获取公共微服务地址
  public getGetWayPublicUrl() {
    return 'https://gateway.leancloud.biz:4443';
    // return 'http://192.168.9.154:8081';
  }

  // 注销登录
  public logout() {
    const loginInfo = JSON.parse(window.sessionStorage.getItem('zw_loginInfo'));

    this.http.get('/cnic-auth/BaseManageActionV1/doLogout/' + loginInfo.cUserUUID)
    .subscribe(
      (res: any) => {
        if (res.code === 1) {
          this.doLogout();
        }
        else {
          this.message.error(res.msg);
        }
      },
      (error: any) => {
        this.message.error('账号退出失败...');
      },
      () => {}
    )
  }
  // 处理退出登录后续操作
  doLogout(){
    // 清空缓存
    window.sessionStorage.removeItem('zw_menuInfo');
    window.sessionStorage.removeItem('zw_currentOrg');
    window.sessionStorage.removeItem('zw_loginInfo');
    window.sessionStorage.removeItem('SID');

    window.sessionStorage.removeItem("lastRouter");

    // 跳转登录页面 及 识别码处理
    const SinID = window.localStorage.getItem('SinID');
    if (SinID !== null && SinID !== undefined) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          code: SinID,
        },
      };
      this.router.navigate(['/login'], navigationExtras);
    } else {
      this.router.navigate(['/login']);
    }
  }


  // aes加密
  encrypt(value: any): string {
    const key = CryptoJS.enc.Utf8.parse('1234123412ABCDEF'); // 十六位十六进制数作为秘钥
    const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); // 十六位十六进制数作为秘钥偏移量

    const srcs = CryptoJS.enc.Utf8.parse(value);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
  }
  // 解密
  decrypt(value: any): string {
    const key = CryptoJS.enc.Utf8.parse('1234123412ABCDEF'); // 十六位十六进制数作为秘钥
    const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); // 十六位十六进制数作为秘钥偏移量
    const encryptedHexStr = CryptoJS.enc.Hex.parse(value);
    const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decrypt = CryptoJS.AES.decrypt(srcs, key, { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  }

  // 获取当前日期 YYYY_MM_DD
  getNowFormatDateYMD() {
    const dateObj = new Date();
    const seperator1 = "-";
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const date = dateObj.getDate();

    let mouthStr : string;
    let dateStr : string;
    if (month >= 1 && month <= 9) {
      mouthStr = "0" + month.toString();
    }
    if (date >= 0 && date <= 9) {
      dateStr = "0" + date.toString();
    }
    return year + seperator1 + month + seperator1 + dateStr;
  }
  getNowFormatTime(dateTime) {
    const dateObj = new Date(dateTime);
    const seperator1 = "-";
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const date = dateObj.getDate();
    const hour = dateObj.getHours()
    const minute = dateObj.getMinutes()
    const second = dateObj.getSeconds()
    let mouthStr : string;
    let dateStr : string;
    let hourStr : string;
    let minuteStr : string;
    let secondStr : string;
    if (month >= 1 && month <= 9) {
      mouthStr = "0" + month.toString();
    }
    if (date >= 0 && date <= 9) {
      dateStr = "0" + date.toString();
    }
    if (hour >= 0 && hour <= 9) {
      hourStr = "0" + hour.toString();
    }
    if (minute >= 0 && minute <= 9) {
      minuteStr = "0" + minute.toString();
    }
    if (second >= 0 && second <= 9) {
      secondStr = "0" + second.toString();
    }
    return year + seperator1 + month + seperator1 + dateStr+ ' '+hourStr+':'+minuteStr+':'+secondStr
  }
  getNowFormatMonth(dateTime) {
    const dateObj = new Date(dateTime);
    const seperator1 = "-";
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;

    let mouthStr : string;


    if (month >= 1 && month <= 9) {
      mouthStr = "0" + month.toString();
    }

    return year + seperator1 + month
  }

    fillTime = (time,type) => {
    const monthDays = [31,28,31,30,31,30,31,31,30,31,30,31]
      const tempDate = new Date(time)
    if (tempDate instanceof Date) {
      if(tempDate.getFullYear() % 4 === 0){
        monthDays[1] = 29
      }
      if(type==='1'){
        const Time = this.getNowFormatMonth( time) + '-01 00:00:00.000'
        return Time
      }else{
      const Time = this.getNowFormatMonth( time) + '-'+monthDays[tempDate.getMonth()]+ ' 23:59:59.000'
        return Time
      }


    } else {

      return time
    }
  }
  // 全局loading显示状态设置
  setFetchingStatus(fetching: boolean) {
    this.isFetching = fetching;
  }

  // 帆软BI账户登录 临时用
  initFBI (res: any) {
    let BIName : string;
    let BIPass : string;

    switch (res.account.cAccUniqueID) {
      case 'y3msc3eb505c52c04926b1ace043754174b2':
        BIName = 'hefei2';
        BIPass = '123456';
        break;
      case 'i9v7abde112e80f1473f8b32c4b91d914d71':
        BIName = 'hefei1';
        BIPass = '123456';
        break;
      case 'tu5zb170d8cf8e604e2fa2faecfacdbe5b6a':
        BIName = 'zunhua';
        BIPass = '123456';
        break;
      case 'xebi4a49232c9f7e4798b70505d3a7bca040':
        BIName = 'yucheng';
        BIPass = '123456';
        break;
      case 'm8p742eb8cb5d3684004bcdf308890550bd5':
        BIName = 'kejiju';
        BIPass = '123456';
        break;
      case 'l48a2afc9fbc04614cb492055a4a93ee2cc5':
        BIName = 'jingkai';
        BIPass = '123456';
        break;
      case '0u36250117e2b97b401ab867cfd10b09067f':
        BIName = 'lingcheng';
        BIPass = '123456';
        break;
      case 'xdvdd92690ca45dc4dbea5e272356363ca3f':
        BIName = 'qingyun';
        BIPass = '123456';
        break;
      case 'uxqa64b5a045fec14511b0b48a93e3aafa9f':
        BIName = 'dezhou';
        BIPass = '123456';
        break;
      case 'smvt62f8f2fe764b43eba87a2b1da5d65a35':
        BIName = 'decheng';
        BIPass = '123456';
        break;
      case 'butt8565b2c6f8e54a59ad6c2433e4de43d9':
        BIName = 'dezhou';
        BIPass = '123456';
        break;
      default:
        console.log('账套未配置BI用户，BI平台登录失败');
        console.log(JSON.stringify(res.account.cAccUniqueID));
        break;
    }

    // 登录BI平台
    $.ajax({
      url:'/webroot/decision/login/cross/domain?fine_username=' + BIName + '&fine_password=' + BIPass + '&validity=-1&callback=jQuery2110548305828903723_1587523054611&_=1587523054612',
      type: 'GET',
      dataType: 'jsonp',
      timeout: 10000,
      success(data: any) {
        if (data.status === 'success') {
          // 获取BI需要的token
          let statNum = JSON.stringify(data.responseText).indexOf('{');
          let endNum = JSON.stringify(data.responseText).indexOf('}');
          // 开始处理token
          let string = JSON.stringify(data.responseText).substring(statNum, endNum);
          const index = JSON.stringify(data.responseText).indexOf('\\');
          const lastIndex = JSON.stringify(data.responseText).indexOf('\\');
          for (let i = index; i < lastIndex; i++) {
            string = string.replace('\\', '');
          }
          // 再次处理获取accessToken
          statNum = string.indexOf(':') + 1;
          endNum = string.indexOf(',');
          string = string.substring(statNum, endNum);
          // 存入BI需要的token
          window.sessionStorage.setItem('accessToken', string);
        } else if (data.status === 'fail') {
          console.log('login fail!');
        }
      },
      error(data: any) {
        console.log('error');
        // 获取BI需要的token
        let statNum = JSON.stringify(data.responseText).indexOf('{');
        let endNum = JSON.stringify(data.responseText).indexOf('}');
        // 开始处理token
        let string = JSON.stringify(data.responseText).substring(statNum, endNum);
        const index = JSON.stringify(data.responseText).indexOf('\\');
        const lastIndex = JSON.stringify(data.responseText).indexOf('\\');
        for (let i = index; i < lastIndex; i++ ) {
          string = string.replace('\\', '');
        }
        // 再次处理获取accessToken
        statNum = string.indexOf(':') + 1;
        endNum = string.indexOf(',');
        string = string.substring(statNum, endNum);
        // 存入BI需要的token
        window.sessionStorage.setItem('accessToken', string);
      }
    });
  }

  // 登录信息处理
  loginInfoHandle (data : any, SinID: string,nextFun?:Function){
    // 清空路由复用信息
    this.reuseTabService.clear();

    // 存储授权菜单信息
    window.sessionStorage.setItem('zw_menuInfo', JSON.stringify(data.menu));
    window.localStorage.setItem('SinID', SinID);
    // 存储当前组织信息
    this.orgServe.setCurrentOrg(data);

    // 存储用户登录信息
    delete data.listMenu;
    delete data.menu;
    window.sessionStorage.setItem('zw_loginInfo', JSON.stringify(data));
    // 初始化炎黄服务
    this.yhFlowService.initYhSever(nextFun);
  }
}
